"use strict";

/**
 * Global variables
 **/
const accordionItems = document.querySelectorAll(".accordion-inner .collapse");
const normalAccordions = document.querySelectorAll(".accordion");

/**
* Assigns items to parent accordion
* @returns {boolean} - whether the assignment was successful or not
*/
const assignHeroItems = () => {
    if (!accordionItems) {
        return false;
    }

    accordionItems.forEach(accordionItem => {
        let accordionItemParent = accordionItem.closest(".accordion-inner");
        accordionItem.setAttribute("data-parent", "#" + accordionItemParent.id);
    });
};

/**
* Changes the parent of the data-parent attribute for each normal accordion
* @returns {void}
*/
const assignNormalItems = () => {
    normalAccordions.forEach(normalAccordion => {
        normalAccordion.querySelectorAll(".collapse").forEach(item => {
            item.setAttribute("data-parent", "#" + normalAccordion.id);
        });
    });
};

/**
* Binds events to normal and hero items
*/
const bindEvents = () => {
    assignNormalItems();
    assignHeroItems();
};

module.exports = {
    bindEvents
};
